import Compressor from 'compressorjs';
import genererGuid from '@/services/general/genererGuid';


async function compresseFile(file) {
  const res = await new Promise(resolve => {
    Compressor(file, {
      quality: 0.6,
      success(result) {
        resolve(result);
      },
      error() {
        resolve();
      },
    });
  });
  return res;
}
export default async function genererPiecesJointe(files) {
  const newsFiles = [];
  files.forEach(data => {
    newsFiles.push({ ...data });
  });

  const filesCompress = [];

  for (let i = 0; i < newsFiles.length; i += 1) {
    // Automatic compression
    newsFiles[i].error = 'compressing';
    if (newsFiles[i].file && newsFiles[i].file.type.substr(0, 6) === 'image/' && newsFiles[i].file.size > 0) {
      filesCompress.push(compresseFile(newsFiles[i].file));
    }

    // Create a blob field
    newsFiles[i].blob = '';
    const URL = window.URL || window.webkitURL;
    if (URL && URL.createObjectURL) {
      newsFiles[i].blob = URL.createObjectURL(newsFiles[i].file);
    }

    // Thumbnails
    newsFiles[i].thumb = '';
    if (newsFiles[i].blob && newsFiles[i].file.type.substr(0, 6) === 'image/') {
      newsFiles[i].thumb = newsFiles[i].blob;
    }
  }

  const respCompress = await Promise.all(filesCompress);
  respCompress.forEach((resp, i) => {
    newsFiles[i].compressedFile = resp;
  });
  const listePJ = newsFiles.map(dataFile => ({
    size: dataFile.file.size,
    description: '',
    typeId: '',
    nom: dataFile.file.name,
    placeType: dataFile.placeType,
    file: dataFile.file,
    compressedFile: dataFile.compressedFile,
    id: genererGuid(),
  }));

  return listePJ;
}



// WEBPACK FOOTER //
// ./src/services/piecesJointes/genererPiecesJointes.js